import { FC, useEffect } from 'react';
import { observer } from 'mobx-react';

import { PageLoading } from 'modules/common/layout';
import { Store } from './stores';

const StoreProvider: FC = ({ children }) => {
  const store = Store.use();

  useEffect(() => {
    store.touch();
  }, [store]);

  return store.ready ? <>{children}</> : <PageLoading />;
};

export const Provider = observer(StoreProvider);
